import { createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-35da82ea"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "panel-container show",
  id: "panel-body"
}, [
  /*#__PURE__*/_createElementVNode("div", { class: "loader" }, [
    /*#__PURE__*/_createElementVNode("i", { class: "fal fa-spinner-third fa-spin-4x fs-xxl" })
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "row" }, [
    /*#__PURE__*/_createElementVNode("div", { id: "map" })
  ])
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Mo_modal_l = _resolveComponent("Mo_modal_l")!

  return (_openBlock(), _createBlock(_component_Mo_modal_l, {
    ref: "modal_insurance",
    style: {"z-index":"9999"}
  }, {
    title: _withCtx(() => [
      _createTextVNode("マップ")
    ]),
    body: _withCtx(() => [
      _hoisted_1
    ]),
    footer: _withCtx(() => [
      _createElementVNode("button", {
        type: "button",
        class: "btn btn-secondary waves-effect waves-themed",
        "data-dismiss": "modal",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.closeModal()))
      }, " 閉じる ")
    ]),
    _: 1
  }, 512))
}